const closeActiveModal = function () {
  let activeModal = document.querySelector(".modal.active");
  activeModal.classList.remove("active");
  document.body.classList.remove("modal-active");
};
const initModal = function () {
  const overlay = document.querySelector(".modal-overlay");
  const closeButtons = document.querySelectorAll(".modal .close");
  closeButtons.forEach((b) => {
    b.addEventListener("click", (e) => {
      closeActiveModal();
    });
  });
  overlay.addEventListener("click", () => {
    closeActiveModal();
  });

  window.addEventListener("keyup", (e) => {
    if (e.key == "Escape") {
      closeActiveModal();
    }
  });
};

export { initModal, closeActiveModal };
